import moment from 'moment';
import { NEW_TASK, PICKLIST_OPTIONS, TASK_FORM_MODE } from '../lib/constants';

const initialState = {
  task: { ...NEW_TASK, startTime: moment().add(1, 'hour').startOf('hour').toISOString() },
  schema: {},
  formValues: {},
  [PICKLIST_OPTIONS.TASK_TYPE]: {
    isLoading: false,
    items: [],
  },
  [PICKLIST_OPTIONS.ASSIGNEE]: {
    isLoading: false,
    items: [],
  },
  [PICKLIST_OPTIONS.ASSET]: {
    isLoading: false,
    items: [],
  },
  customPicklistOptions: {},
  taskFormMode: TASK_FORM_MODE.CREATE,
  dependentTasks: {
    isLoading: false,
    items: [],
  },
  linkedTasks: {
    isLoading: false,
    items: [],
  },
  templateInfo: {
    isLoading: false,
    items: [],
  },
  parentTaskTemplate: {
    isLoading: false,
    items: [],
  },
  taskHistoryState: {
    isLoading: false,
    items: [],
  },
  taskTypeSelectedisParent: false,
  parentLinkedTask: null,
  stopForSelectedAsset: {},
  [PICKLIST_OPTIONS.PARTS_PICKLIST]: {
    isLoading: false,
    items: [],
  },
  manifestForm: {
    isLoading: false,
    schema: {},
    data: {},
    pickList: [],
    auditLog: null,
  },
  isAdhocFileUploading: false,
  taskEmailHistory: [],
  acceptBulkAccept: false,
  showEquipmentColumnForParentTemplate: false,
  parentTaskTemplateTaskTypesDict: {},
  childTasksDictByWorkflowId: {},
  assetCriteriaTemplate: {
    isLoading: false,
    info: {},
  },
  searchPicklistForForm: {},
};

export default initialState;
